import React, {Component} from 'react';
import {connect} from 'react-redux';
import clearSession from '../../actions/clear-session';
import {havePendingActionToConsider} from '../../reducers/userActivityReducer';
import {showKioskWarning} from "../../reducers/kioskWarningReducer";

class KioskTimeoutKicker extends Component {
    constructor(props) {
        super(props);
        this.kickCallbackWithTimeout = null;
        this.inactivityWarningModalCallbackWithTimeout = null;
    }

    refreshTimeout = (kickTimeoutMilliSeconds, kickTimeoutCallback, windowTimeoutMilliSeconds, windowTimeoutCallback) => {
        if (this.kickCallbackWithTimeout != null) {
            clearTimeout(this.kickCallbackWithTimeout);
        }
        if (this.inactivityWarningModalCallbackWithTimeout != null) {
            clearTimeout(this.inactivityWarningModalCallbackWithTimeout);
        }
        this.kickCallbackWithTimeout = setTimeout(kickTimeoutCallback, kickTimeoutMilliSeconds);
        this.inactivityWarningModalCallbackWithTimeout = setTimeout(() => {
            if (this.props.isKioskUserLogged) {
                windowTimeoutCallback()
            }
        }, windowTimeoutMilliSeconds);
    };

    setUpRefresh() {
        const kickTimeoutMilliSeconds = this.props.kickTimeoutMilliSeconds || 100000;
        const kickTimeoutCallback = this.props.clearSession;

        const windowTimeoutMilliSeconds = kickTimeoutMilliSeconds - this.props.inactivityWarningDialogDurationMilliSeconds;
        const windowTimeoutCallback = this.props.openInactivityWarning;
        this.refreshTimeout(kickTimeoutMilliSeconds, kickTimeoutCallback, windowTimeoutMilliSeconds, windowTimeoutCallback);
    }

    componentDidMount() {
        this.setUpRefresh();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isKioskModeEnabled !== this.props.isKioskModeEnabled && !this.props.isKioskModeEnabled) {
            clearTimeout(this.kickCallbackWithTimeout);
            clearTimeout(this.inactivityWarningModalCallbackWithTimeout);
        }

        if (prevProps.needToConsiderUserAction !== this.props.needToConsiderUserAction &&
            this.props.needToConsiderUserAction &&
            this.props.isKioskModeEnabled) {
            this.setUpRefresh()
        }
    }

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const isKioskModeEnabled = false;

    return {
        kickTimeoutMilliSeconds: 10 * 1000 * 60, // config specified in minutes
        inactivityWarningDialogDurationMilliSeconds: 1000 * 60, // 1 minute
        needToConsiderUserAction: havePendingActionToConsider(state),
        isKioskModeEnabled,
        isKioskUserLogged: state.user.isKioskCustomer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearSession: () => dispatch(clearSession()),
        openInactivityWarning: () => dispatch(showKioskWarning({
            warningType: 'INACTIVITY_WARNING'
        }))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KioskTimeoutKicker);



// WEBPACK FOOTER //
// ./src/components/KioskTimeoutKicker/KioskTimeoutKicker.jsx